import axios from "axios";

const API = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,

  headers: {
    "Content-Type": "application/json",
    "Accept-Language": "jp-jp",
    "x-api-key": process.env.REACT_APP_API_KEY,
  },
});

// Add interceptor
API.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("session_key");
  if (token) {
    config.headers["Authorization"] = token;
  }
  return config;
});

export default API;
